import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import ReachStackerRunner from './ReachStackerRunner'

export const ReachStackerRunnerPage: FC = () => {
  const navigate = useNavigate()
  return <ReachStackerRunner onClose={() => navigate(PATHS.arcade.url)} />
}
